import http from 'utils/http';
import { getPhoneNumbersUrl, getPhoneNumberUrl } from './apiUrls';
import { PhoneNumbersResponse } from './types';

export function getPhoneNumbers(
  workspaceId: string,
  agentId: string,
  countryCode: string,
  areaCode: string,
  numberType?: string
): Promise<PhoneNumbersResponse> {
  const params: Record<string, string | boolean> = {
    country_code: countryCode
  };
  if (areaCode !== 'null') {
    params.area_code = areaCode;
  }
  if (numberType === 'existing') {
    params.number_type = 'existing';
  }
  return http.get(getPhoneNumbersUrl(workspaceId, agentId), params);
}

export function createAgentPhoneNumber(workspaceId: string, agentId: string, payload: any): Promise<any> {
  return http.post(getPhoneNumbersUrl(workspaceId, agentId), payload);
}

export function deleteAgentPhoneNumber(workspaceId: string, agentId: string): Promise<any> {
  return http.delete(getPhoneNumberUrl(workspaceId, agentId));
}
